import React from "react";
import Slider from "react-slick";
import { OFFICERS_PANEL } from "./officers-panel-data";

const OfficersPanelMain = () => {
  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    margin: 0,
    centerMode: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1200,
        settings: { arrows: true, slidesToShow: 2 },
      },
      {
        breakpoint: 767,
        settings: { arrows: false, slidesToShow: 1 },
      },
    ],
  };

  return (
    <div className="student_satisfaction-section pt---50 pb---120 mb---60">
      <div className="container">
        <div className="react__title__section-all pb---30">
          <div className="row">
            <div className="col-md-12 text-center">
              <h6 className="wow animate__fadeInUp" data-wow-duration="0.3s">
                Recognition from Eminent Thinkers & Officers
              </h6>
              <h2
                className="react__tittle wow animate__fadeInUp"
                data-wow-duration="0.5s"
              >
                Voices of Excellence on <br /> IAS Jnani
              </h2>
            </div>
          </div>
        </div>
        <div className="feedreact-slider owl-carousel">
          <Slider {...sliderSettings}>
            {OFFICERS_PANEL.map((officer) => (
              <div className="event__card" key={officer.id}>
                <div
                  className="event__card--content"
                  // style={{ height: "390px" }}
                >
                  <div className="event__card--content-area">
                    <h4 className="review-heading">{officer.reviewHeading}</h4>
                    <div className="parag">{officer.reviewText}</div>
                  </div>
                </div>
                <div className="author-sec">
                  <div className="icon">
                    <img
                      src={officer.image}
                      alt={officer.name}
                      width={50}
                      height={50}
                      style={{ borderRadius: "50%" }}
                    />
                  </div>
                  <div className="text">
                    <h4>{officer.name}</h4>
                    <p>{officer.designation}</p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default OfficersPanelMain;
